import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { newCityCreation } from "./cityAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useNavigate,Link } from 'react-router-dom';
import { getAllCity } from "./cityAction";
import { FaArrowLeft } from 'react-icons/fa';


const initialState = {
  city: "",
  citycode: "",
  status: "",
}

const CreateCity = () => {
  const dispatch = useDispatch();
  const cityRef = useRef(null);
  const navigate = useNavigate();
  const curcodeRef = useRef(null);
  const [newCity, setNewCity] = useState(initialState);
  const [alertStatus, setAlertStatus] = useState('');
  const { register, handleSubmit, formState: { errors }, formState } = useForm({ mode: "onChange" });

  const { cityisLoading, cityCstatus, citymessage,cityCMessage } = useSelector((state) => state.citiesList);
  
  useEffect(() => { }, [newCity]);

  const handleOnChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    setNewCity({ ...newCity, [name]: value });
  };
  console.log(cityCMessage);

  useEffect(() => {
    dispatch(getAllCity());
   
}, [dispatch,cityCMessage]);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    Swal.fire('City Created Successfully!', '', 'success')
    const { city, status } = newCity;
    const newCityCreation1 = {
        city,
        status
    };
    dispatch(newCityCreation(newCityCreation1));
    navigate('/cityList');
    e.target.reset();
  };

  const canSave = Boolean(newCity.city) && Boolean(newCity.status)

  return (
    <>
      
            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-50px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Create New City</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/cityList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
            <Form className="mx-4 my-2" component="form" noValidate autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit(e))}>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridCity">
                  <Form.Label>City Name</Form.Label>
                  <Form.Control type="text" ref={cityRef} name="city" required autoComplete='off' placeholder="Enter City Name" {...register("city", { required: true, minLength: 3 })} onChange={handleOnChange}/>
                  {errors.city && <p className='text-danger'>City Name required</p>}
                </Form.Group>
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" {...register("status", { required: true })} onChange={handleOnChange}>
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                  {errors.status && <p className='text-danger'>Status required</p>}
                </Form.Group>
              </Row>
              <div className="d-grid col-2 mx-auto">
                <Button variant="primary" type="submit" className='align-middle' disabled={!canSave}>
                  Submit
                </Button>
              </div>
              {cityisLoading && (<Spinner variant='info' animation='border' />)}
            </Form>
            </div>
            </div>
            </div>
    </>
  );
}

export default CreateCity;
